export default __webpack_public_path__ + "static/media/sherlock.e49274fc.svg";